import angular from "angular";

import OrganisationOwnerServiceProvidersModuleRouting from "./organisation-owner-service-providers.module.routing";

export default angular
  .module("vt-organisation-owner-service-providers", [])
  .config(OrganisationOwnerServiceProvidersModuleRouting);
